import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import {
  add_answer,
  get_question_details
} from "../../../redux/actions/questionActions";
import loader from "../../../style/loader/loader.scss";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
class giveAnswer extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    const editLink = props.match.params.quesID && `giveAnswer/${props.match.params.quesID}`
    super(props);
    this.state = {
      menuKey: 'GIVE_ANSWER',
      alertMessage: "",
      msgType: "",
      show: false,
      question: "",
      answer: "",
      answerError: "",
      quesID: "",
      path: ["Home","Questions","Give Answer"],
      links: ["home",'questions',editLink],
      isError: false,
      name: ""
    };
    this.validate = this.validate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.clear = this.clear.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleEdit = () => {
    this.setState({ hideForm: false });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  clear() {
    this.setState({ answer: "" });
  }

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      const addData = {
        quesID: this.state.quesID,
        answer: this.state.answer
      };
      this.props.add_answer(addData);
    }
  }

  validate = () => {
    let isError = false;
    if (this.state.answer.length === 0) {
      isError = true;
      this.setState({ answerError: "red" });
    }
    return isError;
  };

  componentWillMount() {
    let quesIDParams = this.props.match.params.quesID
      ? this.props.match.params.quesID
      : "";
    if (quesIDParams !== "") {
      this.setState({ quesID: quesIDParams });
      this.props.get_question_details(quesIDParams);
    }
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    
    if (this.props.addedAnswerResponse !== nextProps.addedAnswerResponse) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("success", nextProps.addedAnswerResponse.message);
      window.scrollTo(0, 0);
      this.clear();
    }
    if (
      this.props.questionDetails !== nextProps.questionDetails &&
      !isEmpty(nextProps.questionDetails)
    ) {
      const name = `${nextProps.questionDetails.firstName} ${
        nextProps.questionDetails.lastName
      }`;
      this.setState({
        question: nextProps.questionDetails.question,
        name: name
      });
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div className="giveAnswer col-lg-12 col-md-12 col-sm-12 col-xs-12">
        {this.props.receivingDetails ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          <div>
            <div className="row">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="col-xs-12">
                <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
              </div>
            </div>
            <div className="panel">
              <header className="panel-heading">Add FAQ</header>
              <div className="panel-body">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={8} xs={12} mdOffset={2}>
                      <form onSubmit={this.handleSubmit}>
                        <Row>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="formQuestion">
                              <ControlLabel>Asked By</ControlLabel>
                              <div style={{ textTransform: "capitalize" }}>
                                {this.state.name}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="formQuestion">
                              <ControlLabel>Question</ControlLabel>
                              <div>
                                {this.state.question.charAt(0).toUpperCase() +
                                  this.state.question.substr(1)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="formAnswer">
                              <ControlLabel>
                                <span style={{ color: "red" }}>*</span>Answer
                              </ControlLabel>
                              <FormControl
                                value={this.state.answer}
                                componentClass="textarea"
                                onChange={this.handleChange}
                                name="answer"
                                placeholder="Answer"
                                style={{ borderColor: this.state.answerError }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="BtnRow">
                          <Col md={12} xs={12}>
                            <Button
                              bsStyle="info"
                              type="submit"
                              id="submitButton"
                              disabled={this.props.sendingAnswer}
                            >
                              Submit
                            </Button>
                            <Button
                              bsStyle="default"
                              onClick={() => this.context.router.history.push(`/questions`)}
                            >
                              Cancel
                            </Button>
                          </Col>
                        </Row>
                      </form>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

giveAnswer.propTypes = {
  add_answer: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sendingAnswer: state.questionReducer.sendingAnswer,
  error: state.questionReducer.error,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  receivingDetails: state.questionReducer.receivingDetails,
  questionDetails: state.questionReducer.questionDetails,
  addedAnswerResponse: state.questionReducer.addedAnswerResponse
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    add_answer,
    get_question_details,
    clearAlert,
    renderAlert
  })
)(giveAnswer);



// WEBPACK FOOTER //
// ./src/app/views/admin/question/GiveAnswer.js